import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { convertDateToUTC } from "../utils/formatters"; // Must convert to UTC before sending, don't delete
import { API_BASE_URL } from "./contractApi.js";
import Cookies from "js-cookie";

const processRouteDates = (dto) => ({
  ...dto,
  ...(dto.startDate && { startDate: convertDateToUTC(dto.startDate) }),
  ...(dto.endDate && { endDate: convertDateToUTC(dto.endDate) }),
});

export const rateApi = {
  createRate: (officeCode, rateDTO) =>
    axios.post(
      `${API_BASE_URL}/organizations/${officeCode}/rates`,
      processRouteDates(rateDTO)
    ),

  getRateById: (officeCode, id) =>
    axios.get(`${API_BASE_URL}/organizations/${officeCode}/rates/${id}`),

  filterSingleOfficeCodeRates: (officeCode, criteria, pageable) => {
    const params = {
      page: pageable?.page || 0,
      size: pageable?.size || 15,
      sort: pageable?.sort || "id,asc",
    };
    return axios
      .post(
        `${API_BASE_URL}/organizations/${officeCode}/rates/filter`,
        criteria,
        { params }
      )
      .catch((error) => {
        console.error("Rate API Error:", {
          method: "filterRates",
          officeCode,
          error: error.response?.data || error.message,
        });
        throw error;
      });
  },

filterRates: (officeCode, criteria, pageable) => {
  // const token = Cookies.get("authToken");
  const officeCodesCookie = Cookies.get("officeCodes");
  const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];
  //const officeCode = officeCodes[0];

  const params = {
    officeCodes: officeCodes.join(","),
    page: pageable?.page || 0,
    size: pageable?.size || 15,
    sort: pageable?.sort || "id,asc",
  };

  return axios
    .post(
      `${API_BASE_URL}/organizations/${officeCode}/rates/filter-for-multioffice`,
      criteria,
      { params },
    )
    .catch((error) => {
      console.error("Rate API Error:", {
        method: "filterRatesForMultiOffice",
        officeCodes,
        error: error.response?.data || error.message,
      });
      throw error;
    });
},

  searchRates: (request, pageable) => {
    const token = Cookies.get("authToken");
    const officeCodesCookie = Cookies.get("officeCodes");
    const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];

    const params = {
      page: pageable?.page ?? 0,
      size: pageable?.size ?? 15,
      sortBy: pageable?.sortBy ?? "updatedAt",
      ascending: pageable?.ascending ?? false,
    };

    const criteria = {
      query: request?.query || "",
      status: ""
    };

    return axios.post(
      `${API_BASE_URL}/partial-details/rate-search`,
      // `criteria` should match your `SearchRequest` shape (e.g., { query: "..." })
      criteria,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Spring will bind a comma-separated header into List<String>
          "Office-Code": officeCodes.join(","),
        },
        params,
        paramsSerializer: { indexes: null },
      }   
      );
    },

  updateRate: (officeCode, id, rateDTO) =>
    axios.put(
      `${API_BASE_URL}/organizations/${officeCode}/rates/${id}`,
      processRouteDates({
        ...rateDTO,
        id,
      })
    ),
  deleteRate: (officeCode, id) =>
    axios.delete(`${API_BASE_URL}/organizations/${officeCode}/rates/${id}`),
};
